import requestMaker from 'lib';

export const listViewReports = data => {
  const baseQuery = `/proxy/prv/mfs/lvr`;
  const { profileId = null, slug = null } = data;
  const params = { profileId, slug };
  return requestMaker(baseQuery, { params });
};

export const canSubscribe = data => {
  const baseQuery = `/proxy/prv/cs/cs`;
  const { profileId = null, userId = null, programId = null } = data;
  const params = { profileId, userId, programId };
  return requestMaker(baseQuery, { params });
};

export const putDietTracker = data => {
  const baseQuery = `/proxy/prv/mfs/pdt`;
  const { params, payload } = data;
  return requestMaker(baseQuery, { params, payload });
};